export const getReverseLangDirection = currentAlignment => {
  if (currentAlignment === 'left') return 'right';else if (currentAlignment === 'right') return 'left';
  return currentAlignment;
};
export const getReverseLangDirectionThankYouMessage = inlineMessage => {
  if (inlineMessage) {
    const regex = / (left);|(right);/gim;
    const style = /style="/gim;
    const hasStyle = inlineMessage.match(style);
    const hasLeftOrRight = inlineMessage.match(regex);
    if (hasStyle) {
      if (hasLeftOrRight) {
        return inlineMessage.replace(regex, ` ${getReverseLangDirection('$1')};`);
      }
      return inlineMessage.replace('style="', 'style="text-align: right;');
    }
    return `<p style="text-align: right;">${inlineMessage}</p>`;
  }
  return inlineMessage;
};